<template>
  <div :id="`${source}_analytics_chart`" class="w-full h-full flex flex-col">
    <FunnelChart v-if="isFunnel" :chart-data="props.chartData" :chart-config="props.chartConfig" />

    <PivotTableChart v-else-if="isPivotTable" :chart-data="props.chartData" />

    <KPIChart v-else-if="isKPI" :chart-data="props.chartData" />

    <TableChart
      v-else-if="isTable"
      :source="source"
      :chart-data="props.chartData"
      @page-change="handlePageChange"
    />

    <ApexChartWrapper
      v-else
      :source="source"
      :chart-type="chartType"
      :chart-data="props.chartData"
      :height="height"
      :show-data-table="props.showDataTable"
    />
  </div>
</template>

<script setup>
import { computed } from "vue";
import {
  isKPIChart,
  isTableChart,
  isFunnelChart,
  isPivotTableChart,
} from "@/src/utils/analyticsChartUtils.js";
import KPIChart from "@/src/components/analytics_components/v3/chart/KPIChart.vue";
import TableChart from "@/src/components/analytics_components/v3/chart/TableChart.vue";
import FunnelChart from "@/src/components/analytics_components/v3/chart/FunnelChart.vue";
import PivotTableChart from "@/src/components/analytics_components/v3/chart/PivotTableChart.vue";
import ApexChartWrapper from "@/src/components/analytics_components/v3/chart/ApexChartWrapper.vue";

const props = defineProps({
  source: { type: String, default: "analytics_chart" },
  chartType: { type: String, required: true },
  chartData: { type: Object, default: () => ({}) },
  chartConfig: { type: Object, default: null },
  height: { type: [String, Number], default: 350 },
  showDataTable: { type: Boolean, default: false },
});

const emit = defineEmits(["pageChange"]);

const isKPI = computed(() => isKPIChart(props.chartType));

const isTable = computed(
  () => isTableChart(props.chartType) && !isPivotTableChart(props.chartType),
);

const isFunnel = computed(() => isFunnelChart(props.chartType));

const isPivotTable = computed(() => isPivotTableChart(props.chartType));

const handlePageChange = (payload) => {
  emit("pageChange", payload);
};
</script>
